export default __webpack_public_path__ + "static/media/schist_96x96.4287b9ac.png";